let recaptchaScriptPromise = null;

const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=ru';

export const loadRecaptchaScript = () => {
    if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
        return Promise.resolve();
    }

    if (recaptchaScriptPromise) {
        return recaptchaScriptPromise;
    }

    recaptchaScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');

        if (existingScript) {
            let attempts = 0;
            const waitForApi = () => {
                if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
                    resolve();
                    return;
                }

                if (attempts >= 50) {
                    reject(new Error('reCAPTCHA API is not available'));
                    return;
                }

                attempts += 1;
                setTimeout(waitForApi, 100);
            };

            existingScript.addEventListener('load', waitForApi, { once: true });
            waitForApi();
            return;
        }

        const script = document.createElement('script');
        script.src = RECAPTCHA_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => {
            recaptchaScriptPromise = null;
            reject(new Error('Failed to load reCAPTCHA script'));
        };
        document.head.appendChild(script);
    });

    return recaptchaScriptPromise;
};

export const renderRecaptchaWidget = (container, siteKey, options = {}) => loadRecaptchaScript().then(() => new Promise((resolve) => {
    window.grecaptcha.ready(() => {
        if (!container || !siteKey) {
            resolve(null);
            return;
        }

        container.innerHTML = '';
        container.className = 'g-recaptcha';
        container.setAttribute('data-sitekey', siteKey);

        try {
            resolve(window.grecaptcha.render(container, {
                sitekey: siteKey,
                callback: typeof options.callback === 'function' ? options.callback : undefined,
                'expired-callback': typeof options.expiredCallback === 'function' ? options.expiredCallback : undefined,
                'error-callback': typeof options.errorCallback === 'function' ? options.errorCallback : undefined,
            }));
        } catch (e) {
            resolve(null);
        }
    });
}));

export const getRecaptchaResponse = (widgetId, container) => {
    const textarea = container && container.querySelector('textarea[name="g-recaptcha-response"]');
    if (textarea && textarea.value) {
        return textarea.value;
    }

    if (typeof window.grecaptcha === 'undefined' || widgetId === null || widgetId === undefined) {
        return '';
    }

    try {
        return window.grecaptcha.getResponse(widgetId) || '';
    } catch (e) {
        return '';
    }
};

export const resetRecaptchaWidget = (widgetId) => {
    if (typeof window.grecaptcha === 'undefined' || widgetId === null || widgetId === undefined) {
        return;
    }

    try {
        window.grecaptcha.reset(widgetId);
    } catch (e) {
        // ignore
    }
};
